import styled from 'styled-components';
import { animated } from 'react-spring';

import { breakpoints } from '../../constants';

export const SvgWrapper = styled(animated.div)`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width: 100%;

    svg {
        width: 100%;
        max-width: 500px;
        height: auto;
        margin: 0 auto;
        padding: 20px;
    }

    @media (${breakpoints.mediumMin}) {
        max-height: 400px;
    }
`;
